module.exports = __webpack_public_path__ + "img/logo_only.18e293f0.svg";